import React, {useCallback, useEffect, useRef, useState} from "react";
import {llattempt} from "../../../../common/utils";
import api from "../../../../common/api";
import {LLPreloader} from "../../index";


export const decodeHtmlEntities = (text) => {
    const textarea = document.createElement('textarea');
    textarea.innerHTML = text;
    return textarea.value;
};

export const RulesArticle = (
    {activeArticleId, setActiveArticleId}
) => {
    const
        [isLoading, setIsLoading] = useState(true),
        [pageContent, setPageContent] = useState('');

    const articleRef = useRef(null);

    const loadArticle = useCallback((id) => {
        return llattempt(
            () =>
                api.user.getHelpArticle(id).then((res) => {
                    if (res.success && res.data?.length) {
                        return res.data[0];
                    } else {
                        //     TODO: error
                    }
                })
        );
    }, []);

    useEffect(() => {
        if (activeArticleId == null) {
            setIsLoading(false);
            return;
        }
        setIsLoading(true);
        loadArticle(activeArticleId).then((res = {}) => {
            const {title, title_text} = res;
            if (title || title_text) {
                setPageContent(`
                <h1>${title}</h1>
                ${decodeHtmlEntities(title_text)}
            `);
            }
            setIsLoading(false);
        })
    }, [activeArticleId]);

    if (isLoading) return (
        <div className="rules__loader-box">
            <LLPreloader/>
        </div>
    );

    return <>
        <div
            className="rules__scroll-to-top"
            onClick={() => {
                articleRef.current.scrollTo({top: 0, behavior: "smooth"});
            }}
        >
            <i className="doruk-mg-arrow-2 scroll-up__icon"/>
        </div>
        <div
            onClickCapture={(event) => {
                const href = event.target.getAttribute('href');
                if (href?.startsWith("p=")) {
                    event.preventDefault();
                    event.stopPropagation();
                    try {
                        const id = parseInt(href.split('=')[1]);
                        setActiveArticleId(id);
                    } catch (e) {
                    }
                }
            }}
            className="rules__article-content"
            ref={articleRef}
        >
            <div dangerouslySetInnerHTML={{__html: pageContent}}/>
        </div>
    </>;
}